// extracted by mini-css-extract-plugin
export var children = "SliceHeader-module--children--9ZbTg";
export var pageSliceHeader = "SliceHeader-module--page-slice-header--7IDWn";
export var pageSliceTitle = "SliceHeader-module--page-slice-title--fV40Y";
export var primary = "#06004d";
export var secondary = "#4dafd7";